var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBadgeTeamRaisedGold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 27.68"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#e9b838",
  d: "M2.3 2.5h18.4v17.93l-4.45 2.32-4.55 2.379a.42.42 0 0 1-.4 0L6.75 22.75 3.8 21.21l-1.5-.78Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.3 2.5v17.93l1.5.78V4h16.9V2.5Z",
  opacity: 0.08
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffe269",
  d: "M22.994 1.5a.13.13 0 0 0-.01-.061 2 2 0 0 0-.03-.209.2.2 0 0 1-.02-.08 2 2 0 0 0-.09-.24 2 2 0 0 0-.14-.25 1 1 0 0 0-.18-.221 1.3 1.3 0 0 0-.21-.189 1 1 0 0 0-.23-.13 1.3 1.3 0 0 0-.26-.09 1.2 1.2 0 0 0-.28-.03H1.464a1.565 1.565 0 0 0-1.46 1.66v19.289a1.68 1.68 0 0 0 .85 1.5l.69.361L5.754 25l4.56 2.379a2.5 2.5 0 0 0 2.38 0L17.254 25l4.9-2.551a1.68 1.68 0 0 0 .85-1.5V1.66a1 1 0 0 0-.01-.16m-20.69 1h18.4v17.93l-4.45 2.32-4.55 2.379a.42.42 0 0 1-.4 0l-4.55-2.379-2.95-1.54-1.5-.78Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M194.062 138.912a.33.33 0 0 1-.1-.238v-7.252l-2.128 1.637a.3.3 0 0 1-.2.071.33.33 0 0 1-.279-.155l-.588-.756a.4.4 0 0 1-.07-.21.33.33 0 0 1 .154-.28l3.136-2.422a.56.56 0 0 1 .349-.1h1.233a.312.312 0 0 1 .336.336v9.128a.34.34 0 0 1-.091.238.32.32 0 0 1-.245.1H194.3a.32.32 0 0 1-.238-.097",
  style: {
    isolation: "isolate"
  },
  transform: "translate(-182.806 -121.27)"
}), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.963 26.33a.5.5 0 0 1-.232-.944l7.676-4a.5.5 0 0 1 .462.887l-7.675 4a.5.5 0 0 1-.231.057M1.254 7.57a.5.5 0 0 1-.5-.5V1.25a.5.5 0 0 1 .5-.5h3.44a.5.5 0 0 1 0 1h-2.94v5.32a.5.5 0 0 1-.5.5M7.638 1.73h-1.5a.5.5 0 0 1 0-1h1.5a.5.5 0 1 1 0 1"
})));
export default SvgBadgeTeamRaisedGold;